import { render, staticRenderFns } from "./EditBotForm.vue?vue&type=template&id=7797d074&"
import script from "./EditBotForm.vue?vue&type=script&lang=js&"
export * from "./EditBotForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports